import { ICellRendererParams } from 'ag-grid-community';
import { KeyboardEvent, useState } from 'react';
import { FieldError } from 'react-hook-form';

import { NumberInput } from 'core/components';
import { useFormContext } from 'core/states';
import { getAgGridTableCellData, isEnterKeyPress, isTabKeyPress } from 'core/utils';

export const QuantityCell = (props: ICellRendererParams) => {
  const [value, setValue] = useState(props.value || '');

  const data = getAgGridTableCellData(props, 'quantity');

  const { control, errors } = useFormContext();

  if (!data) {
    return null;
  }

  const rowIndex = props.node.rowIndex;

  const updateGridValue = () => {
    props.setValue(value);
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (isEnterKeyPress(event) || isTabKeyPress(event)) {
      updateGridValue();
    }
  };

  return (
    <NumberInput
      name={`componentData.${rowIndex}.quantity`}
      control={control}
      error={errors?.componentData?.[rowIndex]?.quantity as unknown as FieldError}
      label={null}
      value={props.value}
      onChange={(event: { target: { value: string } }) => setValue(Number(event.target.value))}
      onKeyDown={handleKeyDown}
      onBlur={updateGridValue}
      slotProps={{
        input: {
          min: 0,
          thousandSeparator: true,
        },
      }}
      disabled={!data.isValid}
    />
  );
};
